import { map } from "rxjs/operators";
export function mapList(mapFunction) {
    return map(list => list.map(mapFunction));
}
export function filterList(predicate) {
    return map(list => list.filter(predicate));
}
